import { UrlTargetEnumTarget } from "@wix/ambassador-forms-v4-form/types";
const redirectToExternalUrl = (redirectOptions) => {
  const urlWithoutProtocol = redirectOptions?.redirectUrl?.replace(
    /^https?:\/\//,
    ""
  );
  const updatedExternalUrl = `https://${urlWithoutProtocol}`;
  window.open(
    updatedExternalUrl,
    redirectOptions?.target === UrlTargetEnumTarget.SELF ? "_self" : "_blank"
  );
};
const getErrorCode = (error) => {
  return error?.response?.data?.details?.applicationError?.code || error?.code && String(error?.code) || error?.response?.data?.details?.validationError?.fieldViolations?.[0]?.data?.errors?.[0]?.errorType || "UNKNOWN";
};
const getErrorList = (error) => {
  return error?.response?.data?.details?.validationError?.fieldViolations?.[0].data.errors;
};
const getFormCustomErrorMessage = (errors) => errors?.filter(
  (error) => error.useCustomErrorMessage && !error.errorPath
)?.[0]?.errorMessage;
const getFieldCustomErrorMessages = (errors) => errors?.filter((error) => error.useCustomErrorMessage && error.errorPath);
const getCheckoutMessage = (text) => {
  return {
    nodes: [
      {
        id: "ymnqxbmks",
        type: "PARAGRAPH",
        paragraphData: {
          textStyle: {
            textAlignment: "CENTER"
          }
        },
        nodes: [
          {
            nodes: [],
            id: "",
            type: "TEXT",
            textData: {
              text,
              decorations: []
            }
          }
        ]
      }
    ],
    metadata: {
      version: 1,
      id: "af4951a2-dd8f-44ec-b2dc-cb4c09f65ee9"
    }
  };
};
export {
  getCheckoutMessage,
  getErrorCode,
  getErrorList,
  getFieldCustomErrorMessages,
  getFormCustomErrorMessage,
  redirectToExternalUrl
};
//# sourceMappingURL=utils.js.map
